export const subscriptionsRouteNames = {
  subscriptions: 'subscriptions-v2',
  subscriptionDetails: 'subscription-details-v2',
}
